/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { HTTP_METHOD } from "@nf/constants";
import { skymillHttpService } from "../../../../services";
import {
  ICanceledSubscriptionModel,
  IConsentListModel,
  ICustomerModel,
  ISubscriptionListModel,
  IUserConsentModel,
  ISubscriptionSwitchResponseModel,
  IConsentModel,
  ICancelSubscriptionSwitchResponseModel,
  ICancelSubscriptionRequestModel,
  IOfferSwitchResponseModel,
  ISubscriptionSwitchRequestModel,
  IUncancelSubscriptionResponseModel,
} from "../models";

export class UserService {
  get url(): string {
    return "/v1";
  }

  public availableConsents = (): Promise<IConsentListModel<IConsentModel[]>> =>
    skymillHttpService.request<IConsentListModel<IConsentModel[]>>({
      method: HTTP_METHOD.GET,
      url: `${this.url}/available-consents`,
    });

  public consents = (): Promise<IConsentListModel<IUserConsentModel[]>> =>
    skymillHttpService.request<IConsentListModel<IUserConsentModel[]>>({
      method: HTTP_METHOD.GET,
      url: `${this.url}/consents`,
    });

  public updateUserConsents = (
    data: IConsentListModel<Partial<IConsentModel>[]>
  ): Promise<void> =>
    skymillHttpService.request<void>({
      data,
      method: HTTP_METHOD.PUT,
      url: `${this.url}/consents`,
    });

  public profile = (): Promise<ICustomerModel> =>
    skymillHttpService.request<ICustomerModel>({
      method: HTTP_METHOD.GET,
      url: `${this.url}/customer`,
    });

  public updateProfile = (
    data: Partial<ICustomerModel>
  ): Promise<ICustomerModel> =>
    skymillHttpService.request<ICustomerModel>({
      data,
      method: HTTP_METHOD.PUT,
      url: `${this.url}/customer`,
    });

  public updateEmail = (email: string): Promise<ICustomerModel> =>
    skymillHttpService.request<ICustomerModel>({
      data: { email },
      method: HTTP_METHOD.PATCH,
      url: `/v2/change-email`,
    });

  public subscriptions = (): Promise<ISubscriptionListModel> =>
    skymillHttpService.request<ISubscriptionListModel>({
      method: HTTP_METHOD.GET,
      url: `/v2/subscriptions`,
    });

  public cancelSubscription = (
    data: ICancelSubscriptionRequestModel
  ): Promise<ICanceledSubscriptionModel> =>
    skymillHttpService.request<ICanceledSubscriptionModel>({
      method: HTTP_METHOD.DELETE,
      url: `${this.url}/subscriptions/${data.id}`,
      data: data.reason,
    });

  public uncancelSubscription = (
    id: number
  ): Promise<IUncancelSubscriptionResponseModel> =>
    skymillHttpService.request<IUncancelSubscriptionResponseModel>({
      method: HTTP_METHOD.PATCH,
      url: `${this.url}/subscriptions/${id}/un-cancel`,
    });

  public offerSwitches = (): Promise<IOfferSwitchResponseModel[]> =>
    skymillHttpService.request<IOfferSwitchResponseModel[]>({
      method: HTTP_METHOD.GET,
      url: `${this.url}/offer-switches`,
    });

  public switchSubscription = (
    data: ISubscriptionSwitchRequestModel
  ): Promise<ISubscriptionSwitchResponseModel> =>
    skymillHttpService.request<ISubscriptionSwitchResponseModel>({
      method: HTTP_METHOD.POST,
      url: `${this.url}/subscription-switches`,
      data,
    });

  public cancelSubscriptionSwitch =
    (): Promise<ICancelSubscriptionSwitchResponseModel> =>
      skymillHttpService.request<ICancelSubscriptionSwitchResponseModel>({
        method: HTTP_METHOD.DELETE,
        url: `${this.url}/subscription-switches`,
      });
}
